import { Comment } from "./comment.model";
import { Topic } from "./topic.model";
import { UserForum } from "./user.model";

export class Denounce {
  constructor(
    public description: string = "",
    public status?: DenounceStatus,
    public created?: Date | string,
    public id?: string,
    public updated?: Date | string,
    public userAuthor?: UserForum
  ) {}
}

export enum DenounceStatus {
  ACCEPTED = "ACCEPTED",
  NOT_ACCEPTED = "NOT_ACCEPTED",
  WAITING_REVIEW = "WAITING_REVIEW",
}

export class DenounceTopic {
  constructor(
    public topic?: Topic,
    public denounces?: Denounce[],
  ) {}
}

export class ListDenounceComments {
  constructor(
    public topic?: Topic,
    public denouncedComments?: DenouncedComment,
  ) {}
}

export class DenouncedComment {
  constructor(
    public comment?: Comment,
    public denounces?: Denounce[]
  ) {}
}